import React from 'react';
import AlephTools from './AlephTools';

export default function App() {
  return <AlephTools />;
}
